import { Component, Inject, Input, OnInit } from '@angular/core';
import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { Profile } from 'src/app/Models/profile.interface';
import {transition, state, style, animate, trigger} from '@angular/animations';
import { UserManager } from 'src/app/Services/UserManager/user-manager';


@Component({
  selector: 'app-profile-sheet',
  templateUrl: './profile-sheet.component.html',
  styleUrls: ['./profile-sheet.component.css', '../profile/profile.component.css']
  // ,
  // animations: [
  //   trigger('visible', [
  //     state('void', style({  opacity: 0, transform: 'translateY(100px)'})),
  //     state('show', style({  opacity: 1, transform: 'trnaslateY(0)'})),
  //     transition('void => *',[ animate('300ms ease-in-out')]),
  //     transition('* => void',[ animate('300ms ease-in-out')]),
  //   ]),
  // ]
})
export class ProfileSheetComponent implements OnInit {
  profile
  showing = false
  message = ""
  constructor(
    // private afs: AngularFirestore,
    // private db: AngularFireDatabase,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: {
      profile: Profile
    },
    private _bottomSheetRef: MatBottomSheetRef<ProfileSheetComponent>,
    private um: UserManager
    ) {
      
      this.profile = data.profile
      // console.log(this.profile)
    }

  ngOnInit(): void {
  }


  close(event: MouseEvent): void {
    this._bottomSheetRef.dismiss();
    event.preventDefault();
  }

  toggleTextArea = () => {
    if(!!this.showing){
      //maybe clear the message here?
    }
    this.showing = !this.showing
  }

  send(event){
    event.preventDefault();
    if(this.message === ""){
      alert("Need a message to send")
    }
  
    this.um.createMessageToStudent(this.profile, this.message)
    this._bottomSheetRef.dismiss()
  }


}

